module.exports = __webpack_public_path__ + "static/media/Justin Hughes_1697504143355.76af652f.png";